import dayjs from "dayjs";
import moment from "moment";
import { autoPluralize } from "./string.utils";
import { isString } from "./typeChecks.utils";
export var YYYYMMDD = 'YYYY-MM-DD';
export var HHmm = 'HH:mm';
export var HHmmss = 'HH:mm:ss';
export var YYYYMMDDHHmm = YYYYMMDD + " " + HHmm;
export var YYYYMMDDHHmmss = YYYYMMDD + " " + HHmmss;
export var ddddMMMMDoYYYYHHmm = "dddd, MMMM Do YYYY, " + HHmm;
export var isYYYYMMDDHHmmss = function (string) { return isString(string) && string.match(/^\d{4}-\d{2}-\d{2}(?:\s\d{2}:\d{2}:\d{2})?$/); };
export var seconds = function (seconds) { return seconds * 1000; };
export var minutes = function (minutes) { return minutes * 60 * 1000; };
export var hours = function (hours) { return hours * 60 * 60 * 1000; };
export var days = function (days) { return days * 24 * 60 * 60 * 1000; };
export var millisecondsToHours = function (ms) { return ms / 60 / 60 / 1000; };
export var millisecondsToMinutes = function (ms) { return ms / 60 / 1000; };
export var humanizeDuration = function (dur) {
    if (dur >= days(1)) {
        return dayjs.duration(dur).humanize();
    }
    else {
        var hours_1 = Math.abs(millisecondsToHours(dur));
        var roundedHours = Math.floor(hours_1);
        var minutes_1 = Math.floor(Math.abs(millisecondsToMinutes(dur)) % 60);
        if (roundedHours === 0)
            return autoPluralize(minutes_1, 'minutes');
        if (minutes_1 < 5)
            return autoPluralize(roundedHours, 'hour');
        return roundedHours + " hr " + minutes_1 + " min";
    }
};
export var getFormattedDate = function (datetime) { return dayjs(datetime).format("DD MMMM YYYY"); };
export var getNowTimestampUtc = function () { return moment.utc().format(YYYYMMDDHHmmss); };
/**
 * create moment given the input value types.
 * in auto mode, if the format matches default laravel format of `YYYY-MM-DD HH:mm:ss`,
 * it will be treated as UTC by default.
 * @param inputTimezoneMode specify which type of timezone (utc/local) the timestamp is.
 */
export var createMoment = function (inputTimezoneMode, value, formatter) {
    if (inputTimezoneMode === void 0) { inputTimezoneMode = 'auto'; }
    switch (inputTimezoneMode) {
        case 'local': return moment(value);
        case 'utc': return moment.utc(value, formatter);
        case 'auto':
        default: {
            if (isYYYYMMDDHHmmss(value))
                return moment.utc(value);
            return moment(value);
        }
    }
};
export var createMomentFn = function (inputTimezoneMode) { return function (value, format) { return createMoment(inputTimezoneMode, value, format); }; };
export var createUTCMoment = createMomentFn('utc');
